import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
const OverView = () => import("../views/OverView.vue")
const Site = () => import("../views/Site.vue")
const Pv = () => import('../views/pvContainer/Pv')
const Container = () => import('../views/pvContainer/Container')

Vue.use(VueRouter);


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

const routes = [{
	path: "/",
	name: "Home",
	component: Home,
	redirect: "OverView",
	children: [{
			path: "/overview",
			name: "OverView",
			component: OverView
		}, {
			path: "/site/:id",
			name: "Site",
			component: Site
		},{
			path: "/pv/:id",
			name: "Pv",
			component: Pv
		},{
			path: "/container/:id",
			name: "Container",
			component: Container
		},
	]
}];

const router = new VueRouter({
	routes,
});

export default router;